import React from 'react';
import ReactDOM from 'react-dom';
import { KatSpinner } from '@amzn/katal-react';
import {Provider} from "react-redux";
import createSagaMiddleware from "redux-saga";
import {applyMiddleware, combineReducers, createStore} from "redux";
import {composeWithDevTools} from "redux-devtools-extension";

import App from './components/App';
import AppInitWrapper from './components/AppInitWrapper';
import './i18n';

import reducers from "src/reducers/combinedReducer";
import combinedSaga from "src/sagas/combinedSaga";

import '@amzn/katal-components/styles.css';
import './index.scss';
import ApplicationState from "src/model/ApplicationState";
import ApiUtil from "src/utils/ApiUtil";
import RevCalMetricsUtil from "src/utils/RevCalMetricsUtil";

const sagaMiddleware = createSagaMiddleware();
const store = createStore(combineReducers<ApplicationState>(reducers), composeWithDevTools(applyMiddleware(sagaMiddleware)));

sagaMiddleware.run(combinedSaga);
ApiUtil.injectMetrics(RevCalMetricsUtil);

// The Suspense component causes React to display the fallback KatSpinner until
// the i18n translation strings have been loaded.

ReactDOM.render(
  <React.StrictMode>
    <AppInitWrapper>
      <React.Suspense fallback={<KatSpinner size='large' />}>
        <Provider store={store}>
          <App />
        </Provider>
      </React.Suspense>
    </AppInitWrapper>
  </React.StrictMode>,
  document.getElementById('root')
);
